import {EditOrderItems} from 'app/features/orders/componentsv1/edit'
import {
  addNewOrderItems,
  setIsDirty,
  selectDeletedItems,
  removeEditOrderItem,
  updateEditOrderItem,
  selectEditOrderId,
  updateEditOrderSummary,
  restoreDeletedItem,
  selectEditOrderItems,
  validateDiscountsAndRefetchTax,
  selectOrderDeliveryMethod,
} from 'app/features/orders/redux/order/orderEditSlice'
import {SearchState, clearSearch} from 'app/features/orders/redux/product/searchProductSlice'
import {FC, useMemo, useRef} from 'react'
import {useSelector, useDispatch} from 'react-redux'
import {RootState} from 'setup'
import filter from 'lodash/filter'

type Props = {}

const OrderItems: FC<Props> = () => {
  const dispatch = useDispatch()
  const productSearch = useSelector<RootState>(({orders}) => orders.product) as SearchState
  const orderItems = useSelector(selectEditOrderItems)
  const deletedItems = useSelector<RootState, any[]>(selectDeletedItems)
  const editOrderId = useSelector<RootState, string>(selectEditOrderId)
  const orderDeliveryMethod = useSelector<RootState>(selectOrderDeliveryMethod)
  const timeoutRef = useRef<any>(null)

  useMemo(() => {
    dispatch(updateEditOrderSummary(orderItems))
  }, [orderItems, dispatch])

  const handleProductChange = async () => {
    dispatch(setIsDirty(true))
    const exec = () => dispatch(validateDiscountsAndRefetchTax())
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current)
    }
    timeoutRef.current = setTimeout(exec, 1000)
  }

  const handleAddProduct = () => {
    dispatch(addNewOrderItems([...mapToModel(productSearch.selectedVariants, editOrderId)]))
    dispatch(clearSearch())
    handleProductChange()
  }

  const handleUpdateItem = (orderItem: any) => {
    dispatch(updateEditOrderItem(orderItem, orderItems))
    handleProductChange()
  }

  const handleRemoveItem = (orderItem: any) => {
    dispatch(removeEditOrderItem(orderItem))
    handleProductChange()
  }

  const handleRestoreItem = (orderItem: any) => {
    dispatch(restoreDeletedItem(orderItem, orderItems))
    handleProductChange()
  }

  const deletedOrderItems = useMemo(() => {
    return filter(deletedItems, ({isLocalNew}) => !isLocalNew)
  }, [deletedItems])

  return (
    <>
      <EditOrderItems
        items={orderItems}
        onAddProduct={handleAddProduct}
        onRemoveItem={handleRemoveItem}
        onUpdateItem={handleUpdateItem}
        isEditMode
        orderDeliveryMethod={orderDeliveryMethod}
      />
      {deletedOrderItems.length > 0 && (
        <EditOrderItems
          title='To Be Refunded'
          hideSearchBar
          items={deletedItems}
          onRemoveItem={handleRestoreItem}
          onUpdateItem={() => null}
          isRefundMode
          isDisableInput
        />
      )}
    </>
  )
}

export default OrderItems

const mapToModel = (items: any[], orderEditId: string) => {
  return items.map((item) => {
    return {
      ...item,
      variantId: item.id,
      quantity: 1,
      isLocalNew: true,
      id: null,
      orderEditId,
      variant: item.name,
      originalQty: 0,
      originalPrice: item.price,
      price: item.discountPrice > 0 ? item.discountPrice : item.price,
      discountPrice: null,
    }
  })
}
